// Native
import { Box, Button, ButtonGroup, DataList, Flex, HStack, Image, Progress, Separator, Stack, Text, useDisclosure } from "@chakra-ui/react"
import { useNavigate } from "react-router"

// Custom
import { Parts, UI } from "components"
import { Styles } from "config"
import useUser from "hooks/useUser"
import usePointsReport from "hooks/usePointsReport"

export function Resume(props){

    const navigate = useNavigate()
    const user = useUser()
    const report = usePointsReport()
    const career = user.data?.consultant?.career?.current_career
    const careerStyle = Styles.pin(career?.id)

    return(
    <UI.Box loading={user.isLoading || report.isLoading} backgroundColor={`${careerStyle.colorPalette}.muted`} {...props}>
        <Text children="Pin atual:" color="GrayText" />
        <HStack>
            <Image src={careerStyle.image_url} h="20px" />
            <Text children={career?.title} fontSize="2xl" fontWeight="bold" color={`${careerStyle.colorPalette}.fg`} />
        </HStack>
        <Text children={<UI.Number.Amount value={career?.award} />} fontSize="lg" fontWeight="bold" />

        <Separator my={2} />

        <Text children="Pontos para o próximo pin:" fontSize="xs" color="GrayText" />
        <Progress.Root maxW="240px" striped animated mt={2} colorPalette="purple" value={report.data?.for_upgrade_percentage}>
            <Progress.Track>
                <Progress.Range />
            </Progress.Track>
        </Progress.Root>
        <Flex justifyContent="space-between" mt={2}>
            <Text fontSize="xs"><UI.Number.Number value={report.data?.qualified} /></Text>
            <Text fontSize="xs"><UI.Number.Number value={report.data?.for_upgrade} /></Text>
        </Flex>

        <ButtonGroup>
            <Button size="xs" variant="ghost" children="Antecipar Ciclo" mt={4} onClick={() => navigate('/pontos')} />
            <Button size="xs" variant="ghost" children="Pins de Qualificação" mt={4} />
        </ButtonGroup>
    </UI.Box>
    )
}

export function Details(props){

    const navigate = useNavigate()
    const user = useUser()
    const report = usePointsReport()
    const pins = useDisclosure()
    const career = user.data?.consultant?.career?.current_career
    const careerStyle = Styles.pin(career?.id)

    return(
    <UI.Box loading={user.isLoading || report.isLoading} backgroundColor={`${careerStyle.colorPalette}.muted`} p={6} borderRadius={4} h="100%">
        <Text children="Pin atual:" color="GrayText" />

        <Stack gap={4}>

            <Box>
                <HStack>
                    <Image src={careerStyle.image_url} h="20px" />
                    <Text children={career?.title} fontSize="2xl" fontWeight="bold" color={`${careerStyle.colorPalette}.fg`} />
                </HStack>
                <Text children={<UI.Number.Amount value={career?.award} />} fontSize="lg" fontWeight="bold" />
            </Box>

            <Box>
                <Text children="Pontos para o próximo pin:" fontSize="xs" color="GrayText" />
                <Progress.Root maxW="240px" striped animated mt={2} colorPalette={careerStyle.colorPalette} value={report.data?.for_upgrade_percentage}>
                    <HStack gap="5">
                        <Progress.Track flex="1">
                            <Progress.Range />
                        </Progress.Track>
                        <Progress.ValueText fontSize="xs"><UI.Number.Number value={report.data?.for_upgrade} /> pontos restantes</Progress.ValueText>
                    </HStack>
                </Progress.Root>
            </Box>
            
            <DataList.Root orientation="horizontal">
                <DataList.Item>
                    <DataList.ItemLabel>Próximo pin:</DataList.ItemLabel>
                    <DataList.ItemValue>{report.data?.next_career?.title}</DataList.ItemValue>
                </DataList.Item>
                <DataList.Item>
                    <DataList.ItemLabel>Premiação:</DataList.ItemLabel>
                    <DataList.ItemValue><UI.Number.Amount value={report.data?.next_career?.award} /></DataList.ItemValue>
                </DataList.Item>
            </DataList.Root>

            <Separator />

            <ButtonGroup>
                <Button size="xs" variant="ghost" children="Pins de Qualificação"  onClick={pins.onOpen} />
            </ButtonGroup>

            <Parts.Dialog.Pins {...pins} />
        </Stack>
    </UI.Box>
    )
}